import { render, staticRenderFns } from "./FrequentQuestionsComponent.vue?vue&type=template&id=02a4ffc8&scoped=true&"
import script from "./FrequentQuestionsComponent.vue?vue&type=script&lang=js&"
export * from "./FrequentQuestionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./FrequentQuestionsComponent.vue?vue&type=style&index=0&id=02a4ffc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a4ffc8",
  null
  
)

export default component.exports